export default "__VITE_ASSET__CfteXcA$__"